import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import { api } from "@/lib/api";

export default function Events() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => setEvents([]));
  }, []);

  if (!events || events.length === 0) return null;

  return (
    <section id="events" className="py-28 lg:py-40 border-t border-white/10" data-testid="events-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-mono-accent text-xs tracking-[0.35em] uppercase text-neon mb-6"
        >
          Events &amp; Updates
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight mb-20"
          data-testid="events-heading"
        >
          Genoum, <span className="text-outline">in motion.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {events.map((event, i) => (
            <motion.article
              key={event.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group card-glow img-zoom border border-white/10 bg-navy-800/40"
              data-testid={`event-card-${i}`}
            >
              {event.image && (
                <div className="relative h-56 lg:h-64 overflow-hidden">
                  <img src={event.image} alt={event.title} className="w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
                  <span className="absolute top-4 left-4 font-mono-accent text-[10px] tracking-[0.2em] uppercase text-neon bg-navy/70 px-3 py-1.5 border border-neon/20">
                    {event.tag}
                  </span>
                </div>
              )}
              <div className="p-7">
                <p className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-slate-500 flex items-center gap-2">
                  <CalendarDays className="w-3.5 h-3.5 text-electric" /> {event.date}
                </p>
                <h3 className="font-display text-xl lg:text-2xl font-bold tracking-tight mt-3 group-hover:text-neon transition-colors duration-300">
                  {event.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed mt-3">{event.description}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
